import React, { useState, useEffect, useContext } from "react";
import { TiUser } from "react-icons/ti";
import { Button } from "antd";
import Cookies from "js-cookie";
import Paginate from "../../components/helpers/Paginate";
import { AxiosCustomGet } from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import { useHistory, Link } from "react-router-dom";
import AppRoutePath from "../../router/AppRoutePath";
import httpclient from "../../components/httpclient";
import Swal from "sweetalert2";
import { PermissionContext } from "../../components/context/PermissionContext";
import Breadcrumb from "../../components/common/Breadcrumb/Breadcrumb";
import Title from "../../components/common/Title/Title";
import CustomTable from "../../components/common/Table/CustomTable";
import { initFilterInput, renderColumns } from "./constants";
import {
  AuthorizationList,
  CanAccess,
} from "../../components/template/authorization/Authorization";

function ListRole(props) {
  const myPermissions = useContext(PermissionContext);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [records, setRecords] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [tablePagination, setTablePagination] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const history = useHistory();

  useEffect(() => {
    getData();
  }, [filterInput]);

  const handleDelete = (role) => {
    setSubmitting(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}role/${role.id}`;

    Swal.fire({
      title: "Hapus Data",
      text: "Apakah anda yakin ingin menghapus role " + role.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        httpclient
          .DELETE(url)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
            // window.location.reload(false);
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
              setSubmitting(false);
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    });
  };

  const getData = () => {
    setLoading(true);
    let params = {
      name: filterInput.searchName,
      page: filterInput.page,
      size: filterInput.pageSize,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}role`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        setRecords(response.data.data.items);
        setFilteredData(response.data.data.items);
        setTotalRecord(response.data.data.total_item);
        setLastPage(response.data.data.last_page);

        setTablePagination({
          current: response.data.data?.page,
          pageSize: response.data.data?.per_page,
          total: response.data.data?.total_item,
        });
        setLoading(false);
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      size: parseInt(pagination.pageSize),
    }));
  };

  const handleSearch = (e) => {
    let value = e.target.value.toLowerCase();
    let result = [];
    result = records.filter((data) => {
      return data.name.toLowerCase().includes(value.toLowerCase());
    });
    setFilteredData(result);
  };

  return (
    <div>
      <div className="p-3">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
            <Title text={"Semua Role"} />
            <Breadcrumb current={"Daftar Role"} />
          </div>
          <div
            style={{
              padding: 13,
              border: "1px solid #DCDCDC",
              borderRadius: 5,
              height: 50,
              width: 222,
            }}
          >
            <div
              style={{
                fontSize: 18,
                color: "#303030",
              }}
            >
              <TiUser
                style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
              />
              <span style={{ fontWeight: 700 }}>{totalRecord}</span> Total Role
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            marginTop: 20,
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <div>
            <div style={{ color: "#A6A6A6" }}>Nama Role</div>
            <input
              type="text"
              className="form-control border-DCDCDC mt-1"
              placeholder="Ketikkan Nama Role"
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <CanAccess
            role={AuthorizationList.create_role}
            yes={
              <Button
                onClick={() => history.push(AppRoutePath.ROLE_ADD_ROLE)}
                style={{
                  height: 36,
                  background: "#2C465C",
                  color: "#FFF",
                  width: 180,
                  borderRadius: 6,
                }}
              >
                + Tambah Role
              </Button>
            }
          />
        </div>

        <div className="mt-3">
          <CustomTable
            columns={renderColumns(handleDelete)}
            data={records}
            loading={loading}
            handleTableChange={handleTableChange}
            pagination={tablePagination}
          />
        </div>
      </div>
    </div>
  );
}

export default ListRole;
